module.exports = __webpack_public_path__ + "img/none_img.3a4fd49b.png";